import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SkeletonFluid extends Vue {
  @Prop({ default: '#ECEBEB' }) color!: String
  @Prop({ default: 3 }) number!: Number
  @Prop({ default: 'auto' }) width!: String
  @Prop({ default: 'auto' }) height!: String
  @Prop({ default: 'x' }) id!: String
  @Prop({ default: '' }) styleInject!: String
}